export const SEARCH_PENDING = "SEARCH_PENDING";
export const SEARCH_DONE = "SEARCH_DONE";
export const IDLE = "IDLE";
export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const INIT = "INIT";



// WEBPACK FOOTER //
// ./src/constants/SearchActionTypes.js